// import React, { useState } from 'react'
import Header from '../components/Header';
import ResetPassword from '../components/ResetPassword';

const ResetPasswordPage = () => {
  return (
    <div className="grid lg:grid-cols-2 lg:gap-6 w-full justify-center">
      <div className="hidden lg:block h-full max-h-screen py-8 sticky top-0">
        <div
          className="h-full w-full rounded-md overflow-hidden bg-cover flex flex-col justify-end bg-center"
          style={{ backgroundImage: 'url(/img/signup.jpg)' }}
        ></div>
      </div>
      <div className="max-w-sm flex flex-col items-start justify-center min-h-screen mx-auto">
        <Header
          heading="Create a new password"
          paragraph="Enter your new password to complete the password reset"
        />

        <ResetPassword />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
